import { render, staticRenderFns } from "./MemberAlertsModal.vue?vue&type=template&id=49f16318&scoped=true&"
import script from "./MemberAlertsModal.vue?vue&type=script&lang=js&"
export * from "./MemberAlertsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f16318",
  null
  
)

export default component.exports